import mime from 'mime-types';

function parseFile(file, mimeType) {
  switch (mimeType) {
    case 'application/json':
      return JSON.stringify(file);

    default:
      return file;
  }
}

export function downloadFileFromUrl(url, filename, inNewWindow = false) {
  const link = document.createElement('a');
  if (link.download !== undefined) {
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    if (inNewWindow) {
      link.setAttribute('target', '_blank');
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export function saveAsFile(file, filename) {
  const mimeType = mime.lookup(filename);
  const blob = new Blob([parseFile(file, mimeType)], {
    type: `${mimeType};charset=utf-8;`,
  });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    const url = URL.createObjectURL(blob);
    downloadFileFromUrl(url, filename);
  }
}

export default function exportToCsv(filename, rows) {
  const processRow = function (row) {
    let finalVal = '';
    for (let j = 0; j < row.length; j++) {
      let innerValue = row[j] === null ? '' : row[j].toLocaleString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      }
      let result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
      if (j > 0) finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  let csvFile = '';
  for (let i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  saveAsFile(csvFile, filename);
}
